import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8e6cf36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Item Name:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Variant title:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Catalog code: ", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Apply for product ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Name:", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Partner:", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Location:", -1))
const _hoisted_12 = { class: "custom-text-mini" }
const _hoisted_13 = { class: "flex items-center justify-start" }
const _hoisted_14 = { class: "text-success" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Select")
const _hoisted_16 = {
  key: 0,
  style: {"width":"100%"},
  class: "text-center"
}
const _hoisted_17 = { class: "flex justify-end mt-6" }
const _hoisted_18 = { class: "flex justify-end mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_save_button = _resolveComponent("save-button")!
  const _component_ConfiguredSetVariant = _resolveComponent("ConfiguredSetVariant")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showModalVisible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showModalVisible) = $event)),
    title: "Edit Catalog Code",
    top: "2vh",
    width: "65%"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "w-full mx-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _hoisted_1,
                    _createTextVNode(" " + _toDisplayString(_ctx.orderItem.itemName), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.variantTitle), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_3,
                    (_ctx.orderItem.catalogCode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.orderItem.catalogCode), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(` (Not have code) `), 1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 24,
                class: "text-right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    checked: _ctx.isApplyForProduct,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeApplyForProduct())),
                    title: "Apply your select to product. And another order with variant automatic using your select."
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeTabName,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeTabName) = $event)),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "Choose",
                name: "choose"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (!_ctx.allowCreateCatalog)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                class: "mx-1",
                                modelValue: _ctx.state.form.partner,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.partner) = $event)),
                                placeholder: "Partner",
                                filterable: "",
                                clearable: "",
                                onChange: _ctx.getListProductCatalog
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.partners, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item._id,
                                      label: item.name,
                                      value: item._id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_select, {
                            class: "mx-1",
                            modelValue: _ctx.state.form.type,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.form.type) = $event)),
                            placeholder: "Catalog Type",
                            onChange: _ctx.getListProductCatalog,
                            filterable: "",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogTypes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.title,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"]),
                          _createVNode(_component_el_select, {
                            class: "mx-1",
                            modelValue: _ctx.state.form.catalog,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.form.catalog) = $event)),
                            placeholder: "Select Catalog",
                            onChange: _ctx.onSelectCatalog,
                            "remote-method": _ctx.getListProductCatalog,
                            remote: "",
                            filterable: "",
                            clearable: "",
                            loading: _ctx.isFetchingCatalog,
                            "loading-text": "Loading data..."
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalogs, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item._id,
                                  label: item.name,
                                  value: item._id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange", "remote-method", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "w-full mt-2" }, {
                    default: _withCtx(() => [
                      (_ctx.state.selectedCatalog)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 24,
                            class: "flex items-center justify-between custom-text-mini"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _hoisted_7,
                                _createTextVNode(" " + _toDisplayString(_ctx.state.selectedCatalog.name), 1)
                              ]),
                              (_ctx.state.selectedCatalog?.fulfillmentPartner?.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(" " + _toDisplayString(_ctx.state.selectedCatalog?.fulfillmentPartner
                    ?.map(item => item.name)
                    ?.toString()), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.selectedCatalog?.fulfillmentLocation?.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _hoisted_11,
                                    _createTextVNode(" " + _toDisplayString(_ctx.state.selectedCatalog?.fulfillmentLocation
                    ?.map(item => item.name)
                    ?.toString()), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (
                _ctx.state.selectedCatalog?.mockupGallery?.length > 0 && _ctx.isViewImage
              )
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.selectedCatalog?.mockupGallery, (mockup) => {
                                return (_openBlock(), _createBlock(_component_el_image, {
                                  key: mockup,
                                  class: "mx-1 border image-200",
                                  src: _ctx.imageUrl(mockup, true, 300),
                                  title: "Click to preview",
                                  lazy: ""
                                }, {
                                  error: _withCtx(() => [
                                    _createVNode(_component_slot_error)
                                  ]),
                                  _: 2
                                }, 1032, ["src"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_ctx.state.selectedCatalog)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "text",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isViewImage = !_ctx.isViewImage))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.isViewImage ? 'Hide image' : 'Show image'), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        class: "mt-3 font-bold text-right"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" (" + _toDisplayString(_ctx.variants?.length || 0) + " variants) ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_el_table, {
                            data: _ctx.variants,
                            "element-loading-text": "Loading...",
                            lazy: "",
                            style: {"width":"100%"},
                            stripe: "",
                            "table-layout": "auto",
                            "max-height": "500px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                "min-width": "12",
                                label: "Variant code"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row?.catalogVariantCode), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "color",
                                label: "Color",
                                "min-width": "10"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_13, [
                                    (scope.row.color.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "w-4 h-4 mr-1 bg-color-variant",
                                          style: _normalizeStyle(`--color:${scope.row.color.value}`)
                                        }, null, 4))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "w-4 h-4 mr-1 bg-color-variant",
                                          style: _normalizeStyle(`--color:${scope.row.color.name}`)
                                        }, null, 4)),
                                    _createElementVNode("div", null, _toDisplayString(scope.row.color.name), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "size",
                                label: "Size",
                                "min-width": "10"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.size.name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Design Qty",
                                "min-width": "8"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(_ctx.detectDesignQty(_ctx.state.selectedCatalog, scope.row)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Design",
                                "min-width": "8"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detectDesignName(
                          _ctx.state.selectedCatalog,
                          scope.row
                        ), (item) => {
                                      return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "suggest",
                                label: "Suggest",
                                "min-width": "10"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(scope.row.suggest ? 'Suggest size' : ''), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Actions",
                                "min-width": "10"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_popconfirm, {
                                    "confirm-button-text": "Confirm",
                                    "cancel-button-text": "Cancel",
                                    "icon-color": "#626AEF",
                                    title: "Order will update FFM code. Confirm change?",
                                    onConfirm: ($event: any) => (_ctx.onChooseVariantCode(scope.row)),
                                    width: "20%"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createVNode(_component_el_button, { size: "small" }, {
                                        default: _withCtx(() => [
                                          _hoisted_15
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"]), [
                            [_directive_loading, _ctx.isLoading]
                          ]),
                          (_ctx.variants?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_el_button, {
                                  size: "small",
                                  type: "text",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClickShowMore()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.isShowAllVariant ? 'Hide' : 'Load more'), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.activeTabName === 'choose')
                      ? (_openBlock(), _createBlock(_component_close_button, {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Text",
                name: "text"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    gutter: 24,
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.catalogCodeText,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.catalogCodeText) = $event)),
                            autosize: { minRows: 5, maxRows: 10 },
                            type: "textarea"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.activeTabName === 'text')
                      ? (_openBlock(), _createBlock(_component_save_button, {
                          key: 0,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSaveCatalogWithText()))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Combo",
                name: "combo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ConfiguredSetVariant, {
                    item: _ctx.itemInfo,
                    onClose: _ctx.saveData
                  }, null, 8, ["item", "onClose"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}